import React, { Component } from "react";
import * as enums from "../../../../utils/EnumMapping";
import MainTable from "../../../common/table/MainTable";
import IncomingAggregatePanel from "./IncomingAggregatePanel";
import * as columns from "./IncomingBillColumns";
import NewIncomingBill from "./NewIncomingBill";

class IncomingBill extends Component {
  enrich = (data) => {
    data.map((item) => {
      item.rowType = "INCOMING_BILL";
      item.paymentMethodLabel = enums.getLabel(
        enums.paymentMethods,
        item.paymentMethod
      );
      item.currencyLabel = enums.getLabel(enums.currencies, item.currency);
      item.stateLabel = enums.getLabel(enums.states, item.state);
      item.typeLabel = enums.getLabel(enums.billTypes, item.type);
      return item;
    });
    // console.log(data)
    return data;
  };

  render() {
    return (
      <MainTable
        divClassName="incomingBill"
        tableName="Bejövő számlák"
        newObjectLabel="Új számla hozzáadása"
        path="/api/incomingbills"
        enrich={this.enrich}
        columns={(refresh) => columns.columns(refresh)}
        dialogContent={(refresh, close) => (
          <NewIncomingBill refresh={refresh} close={close} />
        )}
        needAggregate={true}
        aggregatePanel={(rows) => <IncomingAggregatePanel rows={rows} />}
        syncInvoices={{ mode: "INBOUND" }}
      />
    );
  }
}

export default IncomingBill;
